export const APP_CONFIG = {
  siteName: 'Gocity Groups GistUZone',
  siteDescription: 'Your premier destination for professional business insights, market analysis, and industry trends.',
  apiBaseUrl: import.meta.env.VITE_API_BASE_URL || 'http://localhost:3000',
  maxUploadSize: 10 * 1024 * 1024, // 10MB
  supportedImageTypes: ['image/jpeg', 'image/png', 'image/gif'],
  supportedVideoTypes: ['video/mp4', 'video/webm'],
  defaultAvatarUrl: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150',
  pagination: {
    defaultLimit: 10,
    maxLimit: 50
  },
  toast: {
    duration: 3000
  }
} as const;